module.exports = __webpack_public_path__ + "static/hunger_spanish-2fbdd3a9a31abce155d6f3ed8e3da432.png";